import { ContactRelationship, InsuranceSubscriberRelationship } from 'domains/client';
import { invert } from 'lodash';

/**
 * Single source of truth for relationships between client, contact and insurance subscriber. The definition
 * of relationship codes and internal enums
 */

/**
 * API way of representing relationships between
 * client - contact
 */
export const CONTACT_RELATIONSHIP_CODE_MAP = {
  [ContactRelationship.Parent]: '32',
  [ContactRelationship.Client]: '18',
  [ContactRelationship.Dependent]: '19',
  [ContactRelationship.FamilyMember]: '21',
  [ContactRelationship.LegalGuardian]: '21',
  [ContactRelationship.Physician]: '21',
  [ContactRelationship.Spouse]: '01',
  [ContactRelationship.Other]: 'G8',
} as const satisfies Record<ContactRelationship, string>;

export type RelationshipCode = (typeof CONTACT_RELATIONSHIP_CODE_MAP)[keyof typeof CONTACT_RELATIONSHIP_CODE_MAP];

/**
 * API way of representing relationships between
 * client - insurance subscriber
 */
export const SUBSCRIBER_RELATIONSHIP_CODE_MAP: Record<InsuranceSubscriberRelationship, RelationshipCode> = {
  [InsuranceSubscriberRelationship.Child]: '19',
  [InsuranceSubscriberRelationship.Self]: '18',
  [InsuranceSubscriberRelationship.Spouse]: '01',
  [InsuranceSubscriberRelationship.Other]: 'G8',
} as const;

export const CODE_TO_SUBSCRIBER_RELATIONSHIP_MAP: Record<string, InsuranceSubscriberRelationship> = invert(
  SUBSCRIBER_RELATIONSHIP_CODE_MAP,
) as Record<string, InsuranceSubscriberRelationship>;
